
import { ProcedureInstanceDocBase } from "../procedure-instance/procedure-instance-doc.model"
import { DynFormBase } from "../dyn-form/dyn-form.model"
import { SectionLayoutMetadata } from "../dyn-form/form-metadata/layout/section-layout.model"
import { EFormHeaderModelValue, EFormSectionModelValueResponse } from "../eform/eform-api.model"
import { EntityInfoBase } from "../entity/entity-info.model"
import { ProcedureInstanceBase } from "../procedure-instance/procedure-instance.model"
import { ProcedureBase } from "../procedure/procedure.model"
import { ServiceBase } from "../service/service.model"

export class PrintProcedureInstanceInfoBase {

    eformHeaderModelValue!: { ok: boolean, entity: EFormHeaderModelValue, messageCode: string }
    procedureInstanceTOs: ProcedureInstanceBase[] = []
    config!: { procedureTO: ProcedureBase, serviceTO: ServiceBase }
    jsonSectionForm: SectionLayoutMetadata[] = []
    eformSectionModelValue: EFormSectionModelValueResponse[] = []
    dynForms: DynFormBase[] = []
    attachments: ProcedureInstanceDocBase[] = []
    messageCode: string | null = null
    procedureInstanceEntityInfo!: { promoterEntityInfo: EntityInfoBase, receptorEntityInfo: EntityInfoBase }


    static from(pi: PrintProcedureInstanceInfo): PrintProcedureInstanceInfoBase {

        let current = new PrintProcedureInstanceInfoBase();
        Object.assign(current, pi)

        if (pi.procedureInstanceTOs != null && pi.procedureInstanceTOs.length > 0) {
            current.procedureInstanceTOs = [ProcedureInstanceBase.from(pi.procedureInstanceTOs[0])]
        }
        if (pi.config != null) {
            current.config.procedureTO = ProcedureBase.from(pi.config.procedureTO)
            current.config.serviceTO = ServiceBase.fromService(pi.config.serviceTO)
        }

        if (pi.dynForms != null && pi.dynForms.length > 0) {
            current.dynForms = [DynFormBase.from(pi.dynForms[0])]
        }

        if (pi.attachments != null && pi.attachments.length > 0) {
            current.attachments = []
            pi.attachments.forEach(a => {
                current.attachments.push(ProcedureInstanceDocBase.from(a))
            })
        }

        if (pi.procedureInstanceEntityInfo != null) {
            current.procedureInstanceEntityInfo.promoterEntityInfo = EntityInfoBase.fromEntityInfo(pi.procedureInstanceEntityInfo.promoterEntityInfo)
            current.procedureInstanceEntityInfo.receptorEntityInfo = EntityInfoBase.fromEntityInfo(pi.procedureInstanceEntityInfo.receptorEntityInfo)

        }

        return current;
    }

}

export interface PrintProcedureInstanceInfo extends PrintProcedureInstanceInfoBase {

}